import React from 'react'

export const Fill: React.FC = () => <div className="fill"></div>
